import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types/product';
import { formatPrice } from '../utils/format';
const stockLabels: Record<Product['stock'], {
  text: string;
  className: string;
}> = {
  'en-stock': {
    text: 'En stock',
    className: 'bg-sauge/20 text-[#3F6B59]'
  },
  'dernieres-pieces': {
    text: 'Dernières pièces',
    className: 'bg-framboise-soft text-framboise-dark'
  },
  'sur-commande': {
    text: 'Sur commande',
    className: 'bg-ciel/20 text-[#256070]'
  }
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const stock = stockLabels[product.stock];
  return <article className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-[0_1px_0_rgba(27,42,94,0.06)] ring-1 ring-encre/8" data-id="element-121" data-mp="td1kr3oo8yaw">
      <Link to={`/produit/${product.slug}`} className="block overflow-hidden bg-creme-deep" data-id="element-122" data-mp="yaa59axalefb">
        <img src={product.image} alt={product.name} loading="lazy" className="aspect-[4/5] w-full object-cover object-top transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-123" data-mp="2v6hbs1oo8f6e" />
      </Link>

      <div className="flex flex-1 flex-col p-5" data-id="element-124" data-mp="3gzvnx3f90rxb">
        <div className="flex items-start justify-between gap-3" data-id="element-125" data-mp="3gy11tls8qtrn">
          <h3 className="font-display text-xl font-bold leading-tight text-encre" data-id="element-126" data-mp="3czbsc4abpwda">
            <Link to={`/produit/${product.slug}`} className="hover:text-framboise-dark" data-id="element-127" data-mp="3808mwiqflo4s">
              {product.name}
            </Link>
          </h3>
          <span className={`shrink-0 rounded-full px-2.5 py-1 text-[11px] font-bold ${stock.className}`} data-id="element-128" data-mp="8i7v1ynpowns">
            {stock.text}
          </span>
        </div>

        <p className="mt-2 text-sm leading-relaxed text-encre-soft" data-id="element-129" data-mp="3vnqi6o8wn4ci">{product.tagline}</p>

        {product.colorways && <div className="mt-4 flex items-center gap-1.5" data-id="element-130" data-mp="3qpp128v1hf3o">
            {product.colorways.slice(0, 8).map(c => <span key={c.name + (c.code ?? '')} title={c.name} className="h-4 w-4 rounded-full ring-1 ring-inset ring-black/10" style={{
          backgroundColor: c.hex
        }} data-id="element-131" data-mp="2k7idag603gxo" />)}
            <span className="ml-1 text-xs font-semibold text-encre-light" data-id="element-132" data-mp="2lpqsyusvqu9g">
              {product.colorways.length} coloris
            </span>
          </div>}

        <div className="mt-auto flex items-end justify-between gap-3 pt-5" data-id="element-133" data-mp="2cpu8749m2fjo">
          <p className="leading-tight" data-id="element-134" data-mp="1y1fx6621jks1">
            <span className="font-display text-2xl font-extrabold text-framboise" data-id="element-135" data-mp="1y0ekjx5dmq87">
              {formatPrice(product.price)}
            </span>
            <span className="block text-xs font-semibold text-encre-light" data-id="element-136" data-mp="22u8y0iue28yu">{product.unit}</span>
          </p>
          <Link to={`/produit/${product.slug}`} className="rounded-full border-2 border-encre px-4 py-2 text-sm font-bold text-encre transition-colors duration-150 ease-out hover:bg-encre hover:text-creme" data-id="element-137" data-mp="1oyyc3uy4gy6m">
            Voir
          </Link>
        </div>
      </div>
    </article>;
}